/** @format */

import { Component, Input } from '@angular/core';

@Component({
	selector: 'homefield-strikethrough-price',
	templateUrl: './strikethrough-price.component.html',
	styleUrl: './strikethrough-price.component.scss',
	standalone: false
})
export class HomefieldStrikethroughPriceComponent {
	@Input() isClearance = false;
	@Input() isSeePriceInCart = false;
	@Input() pricingInfo: any;
}
